class Configuration {
    /**
     * Add theme to localStorage
     * 
     * @param {"dark" | "light"} themeType 
     */
    addTheme(themeType) {
        localStorage.setItem("configuration-theme", themeType);
    }

    /**
     * Get theme
     * 
     * @returns {"dark" | "light"}
     */
    getTheme() {
        return localStorage.getItem("configuration-theme") || undefined;
    }

    /**
     * Remove current theme mode
     */
    clearTheme() {
        return localStorage.removeItem("configuration-theme");
    }

    /**
     * Add new language localStorage
     * @param {"vi" | "en"} lang 
     */
    addLanguage(lang) {
        localStorage.setItem("language", lang);
    }

    /**
     * Get language current saving on localStorage
     * @returns {string}
     */
    getLanguage() {
        return localStorage.getItem("language") || "vi";
    }

    /**
     * Clear current language on localStorage
     */
    clearLanguage() {
        localStorage.removeItem("configuration-lang");
    }
}

const configuration = new Configuration();

export default configuration;


// WEBPACK FOOTER //
// ./src/core/helpers/configuration.js